import React, { FC } from 'react';
import { connect } from 'react-redux';
import CompleteProfile from '../../screens/Products/Plural/CompleteProfile';

import './style.scss';

const Profile: FC<any> = (): JSX.Element => {
  return (
    <React.Fragment>
      <div className='profile-wrapper'>
        <CompleteProfile />
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ sidebarReducer }) => ({
  isCollapsed: sidebarReducer.isCollapsed,
});

export default connect(mapStateToProps)(Profile);
